import React, { useState } from "react";
import { CircularProgress, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import { IMachine } from '../types';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from './useWindowSize';
import { makeSafeFileName } from "../helpers/utils";

interface IProps {
  dense?: boolean;
  machine: IMachine;
}


const useStyles = makeStyles((theme: Theme) => ({
  // loadingElement: {
  //   position: 'absolute',
  //   height: 'calc(100vH - (88px + 56px))',
  //   width: '100%',
  //   display: 'flex',
  //   flexDirection: 'column',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  // },
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: 'auto',
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
  },
  noPaddingBottom: {
    paddingBottom: 0,
  },
}));

export default function DownloadList(props: IProps) {
  const { machine, dense } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const isDesktop =
    !!windowSize && !!windowSize.width && windowSize.width > 1024
      ? true
      : false;

  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);

    try {
      console.log("Calling {machineId}/locations");
      const response = await fetch(
        `/api/machines/${machine.id}/locations`
      );

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // sinnvollen Namen erzeugen
      const rawSerial = machine.serialNumber ?? machine.id;
      const safeSerial = makeSafeFileName(rawSerial);
      const locationLabel = `${t('navigation.locations').trim()}`;

      link.download = `${locationLabel}_${safeSerial}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.iconWrapper}>
      <IconButton 
        aria-label="locations" 
        onClick={handleClick} 
        title={`${t('navigation.locations')} `}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <GetAppIcon color="action" />
        )}
      </IconButton>
      <Typography
        align="center"
        variant="caption"
        color="textSecondary"
        component="p"
      >
          {`${t('navigation.locations')} `}
      </Typography>
    </div>
  );
}
